import { render, staticRenderFns } from "./ChangePhone.vue?vue&type=template&id=34814efb&scoped=true"
import script from "./ChangePhone.vue?vue&type=script&lang=js"
export * from "./ChangePhone.vue?vue&type=script&lang=js"
import style0 from "./ChangePhone.vue?vue&type=style&index=0&id=34814efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34814efb",
  null
  
)

export default component.exports